import React from "react";
import { Container, Typography, Button, Stack } from "@mui/material";

const HomeDetailed = ({ setView }) => {
	  const buttons = [
		      { label: "Training", view: "guidedtraininghome", variant: "contained" },
		      { label: "Assessments", view: "caregiverquiz", variant: "outlined" },
		      { label: "Assigned Simulations", view: "simulations", variant: "contained" },
		      { label: "Coaching", view: "coachinghome", variant: "outlined" },
		      { label: "Analytics", view: "analytics", variant: "contained" },
		      { label: "Simulation Configuration", view: "configuration", variant: "outlined" },
		      { label: "Roadmap Conversations", view: "prettyList", variant: "contained" }
		    ];

	  return (
		      <Container maxWidth="md" sx={{ mt: 4 }}>
		        <Typography variant="h4" gutterBottom>
		          Training, Excellence, Coaching, Analytics, Growth
		        </Typography>
		        <Stack spacing={2}>
		          {buttons.map(({ label, view, variant }) => (
				            <Button
				              key={view}
				              variant={variant || "text"}
				              onClick={() => setView(view)}
				            >
				              {label}
				            </Button>
				          ))}
		        </Stack>
		      </Container>
		    );
};

export default HomeDetailed;

